<canvas
    baseChart
    [data]="doughnutChartData"
    [type]="doughnutChartType"
>
</canvas>